import { render, staticRenderFns } from "./RegistryWizardSecondStep.vue?vue&type=template&id=70dca039&scoped=true&"
import script from "./RegistryWizardSecondStep.vue?vue&type=script&lang=js&"
export * from "./RegistryWizardSecondStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dca039",
  null
  
)

export default component.exports